<template>
  <div class="kpi-list">
    <div class="kpi-list__section kpi-list__section--date">
      <div class="timestamp">
        <div class="label">Data For Today</div>
        <div class="amount">as @ {{ formatDateTime(this.lastUpdated) }}</div>
      </div>
    </div>
    <!-- REGISTRATIONS -->
    <div class="kpi-list__section kpi-list__section--result">
      <div class="label subheading">REGISTRATIONS TOTAL</div>
      <div class="value">
        <div class="amount">{{ this.registrations }}</div>
        <div
          class="percentage"
          :class="
            this.registrationsChangePercent <= -1 ? 'negative' : 'postive'
          "
        >
          <q-icon
            size="sm"
            :name="
              this.registrationsChangePercent <= -1
                ? 'arrow_drop_down'
                : 'arrow_drop_up'
            "
          />{{ formatKPIPercentage(this.registrationsChangePercent) }}
        </div>
      </div>
    </div>
    <!-- DEPOSITORS -->
    <div class="kpi-list__section kpi-list__section--result">
      <div class="label subheading">DEPOSITORS TOTAL</div>
      <div class="value">
        <div class="amount">{{ this.depositors }}</div>
        <div
          class="percentage"
          :class="this.depositorsChangePercent <= -1 ? 'negative' : 'postive'"
        >
          <q-icon
            size="sm"
            :name="
              this.depositorsChangePercent <= -1
                ? 'arrow_drop_down'
                : 'arrow_drop_up'
            "
          />{{ formatKPIPercentage(this.depositorsChangePercent) }}
        </div>
      </div>
    </div>
    <!-- First Time DEPOSITORS -->
    <div class="kpi-list__section kpi-list__section--result">
      <div class="label subheading">FTDs TOTAL</div>
      <div class="value">
        <div class="amount">{{ this.firstTimeDepositors }}</div>
        <div
          class="percentage"
          :class="
            this.firstTimeDepositorsChangePercent <= -1 ? 'negative' : 'postive'
          "
        >
          <q-icon
            size="sm"
            :name="
              this.firstTimeDepositorsChangePercent <= -1
                ? 'arrow_drop_down'
                : 'arrow_drop_up'
            "
          />{{ formatKPIPercentage(this.firstTimeDepositorsChangePercent) }}
        </div>
      </div>
    </div>
    <!-- DEPOSIT -->
    <div class="kpi-list__section kpi-list__section--result">
      <div class="label subheading">DEPOSIT AMOUNT</div>
      <div class="value">
        <div class="amount">
          {{ formatCurrencyRounded(this.depositAmount) }}
        </div>
        <div
          class="percentage"
          :class="
            this.depositAmountChangePercent <= -1 ? 'negative' : 'postive'
          "
        >
          <q-icon
            size="sm"
            :name="
              this.depositAmountChangePercent <= -1
                ? 'arrow_drop_down'
                : 'arrow_drop_up'
            "
          />{{ formatKPIPercentage(this.depositAmountChangePercent) }}
        </div>
      </div>
    </div>
    <!-- GGR -->
    <div class="kpi-list__section kpi-list__section--result">
      <div class="label subheading">GGR AMOUNT</div>
      <div class="value">
        <div class="amount">{{ formatCurrency(this.ggr) }}</div>
        <!-- <div
          class="percentage"
          :class="this.ggrChangePercent <= -1 ? 'negative' : 'postive'"
        >
          <q-icon
            size="sm"
            :name="
              this.ggrChangePercent <= -1 ? 'arrow_drop_down' : 'arrow_drop_up'
            "
          />{{ formatKPIPercentage(this.ggrChangePercent) }}
        </div> -->
      </div>
    </div>
    <!-- NGR -->
    <div class="kpi-list__section kpi-list__section--result">
      <div class="label subheading">NGR AMOUNT</div>
      <div class="value">
        <div class="amount">{{ formatCurrency(this.ngr) }}</div>
        <!-- <div
          class="percentage"
          :class="this.ngrChangePercent <= -1 ? 'negative' : 'postive'"
        >
          <q-icon
            size="sm"
            :name="
              this.ngrChangePercent <= -1 ? 'arrow_drop_down' : 'arrow_drop_up'
            "
          />{{ formatKPIPercentage(this.ngrChangePercent) }}
        </div> -->
      </div>
    </div>
    <q-inner-loading :showing="visible">
      <q-spinner size="25px" color="secondary" class="kpi-list__spinner" />
    </q-inner-loading>
  </div>
</template>
<script>
import { formatDateTime } from "@/utils/formatDate";
import { formatKPIPercentage } from "@/utils/formatPercentage";
import { formatCurrencyRounded, formatCurrency } from "@/utils/formatCurrency";
export default {
  name: "KPIList",
  props: {
    dataset: String,
    filter: Object,
  },
  data() {
    return {
      visible: true,
      interval: null,
      lastUpdated: null,
      depositAmount: 0,
      depositAmountChangePercent: 0,
      depositors: 0,
      depositorsChangePercent: 0,
      ggr: 0,
      ggrChangePercent: 0,
      ngr: 0,
      ngrChangePercent: 0,
      registrations: 0,
      registrationsChangePercent: 0,
      firstTimeDepositors: 0,
      firstTimeDepositorsChangePercent: 0,
    };
  },
  methods: {
    formatDateTime,
    formatKPIPercentage,
    formatCurrencyRounded,
    formatCurrency,
    // Fetch all site data using siteId, networkId and operatorId
    async fetchData(siteId, networkId, operatorId) {
      this.visible = true;

      const payload = {
        filterOptions: {
          siteIds: siteId ? [siteId] : [],
          networkId,
          operatorId,
        },
        report: "live-dashboard",
        dataset: this.$props.dataset.replace(/ /g, ""),
      };

      await this.$store
        .dispatch("fetchData", payload)
        .then((response) => {
          // Assigned response values to markup tags
          this.lastUpdated = response.data[0].LastUpdated;
          this.depositAmount = response.data[0].Deposit_Amount;
          this.depositAmountChangePercent =
            response.data[0].DepositAmountChangePercent;
          this.depositors = response.data[0].Depositors;
          this.depositorsChangePercent =
            response.data[0].DepositorsChangePercent;
          this.ggr = response.data[0].GGR;
          this.ggrChangePercent = response.data[0].GGRChangePercent;
          this.ngr = response.data[0].NGR;
          this.ngrChangePercent = response.data[0].NGRChangePercent;
          this.registrations = response.data[0].Registrations;
          this.registrationsChangePercent =
            response.data[0].RegistrationsChangePercent;
          this.firstTimeDepositors = response.data[0].FirstTimeDepositors;
          this.firstTimeDepositorsChangePercent =
            response.data[0].FirstTimeDepositorsChangePercent;
        })
        .catch((e) => {
          this.errors.push(e);
        });
      this.visible = false;
    }
  },
  watch: {
    // If site selector values are updated - propogate changes into KPI list
    filter: function(filterOption) {
      this.fetchData(
        filterOption.siteId,
        filterOption.networkId,
        filterOption.operatorId
      );
      this.visible = true;
      clearInterval(this.interval);
      // After fetch has been made, set a 3 minute interval to retrieve latest data
      this.interval = setInterval(() => {
        this.fetchData(
          filterOption.siteId,
          filterOption.networkId,
          filterOption.operatorId
        );
      }, 180000);
    },
  },
  mounted() {
    // Fetch data once the component has rendered on screen
    this.fetchData(
      this.$store.state.siteFilter.id,
      this.$store.state.networkFilter.id,
      this.$store.state.selectedOperator.id
    );
    // After fetch has been made, set a 3 minute interval to retrieve latest data
    this.interval = setInterval(() => {
      this.fetchData(
        this.$store.state.siteFilter.id,
        this.$store.state.networkFilter.id,
        this.$store.state.selectedOperator.id
      );
    }, 180000);
  },
  // Clear interval when page demounted to prevent memory leak
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.kpi-list {
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  font-family: Barlow;
  @media only screen and (min-width: 768px) {
    grid-template-columns: 150px 1fr 1fr 1fr;
  }
  @media only screen and (min-width: 1300px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  }
  &__section {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    &--date {
      grid-row: span 1;
      grid-column: span 1;
      width: 100%;
      min-width: 0;
      padding: 10px;
      border-bottom: 1px solid #ebeff2;
      @media only screen and (min-width: 768px) {
        height: 100%;
        grid-row: span 2;
        border-right: 1px solid #ebeff2;
        border-bottom: 0;
      }
      @media only screen and (min-width: 1300px) {
        grid-row: span 1;
        border-bottom: 0;
      }
    }
    &--result {
      width: 100%;
      min-width: 0;
      height: 100%;
      min-height: 50px;
      grid-column: span 1;
      justify-content: space-between;
      grid-row: span 1;
      padding: 0 10px 0 10px;
      font-weight: 600;
      border-bottom: 1px solid #ebeff2;

      @media only screen and (min-width: 768px) {
        padding: 0 15px 0 15px;
        border-bottom: 0;
      }
      @media only screen and (min-width: 1300px) {
        border-right: 1px solid #ebeff2;
        padding: 0 10px 0 10px;
      }
      &:last-child {
        border-bottom: 0;
      }
    }
    .timestamp {
      text-align: left;
      width: inherit;
      .label {
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        color: #696969;
      }
      .amount {
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        color: #696969;
      }
    }
    .label {
      padding-right: 5px;
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      color: #13110c;
    }
    .subheading {
      max-width: 125px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .value {
      text-align: right;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: center;
      .amount {
        font-size: 16px;
        line-height: 1.4;
        color: #458edd;
      }
      .percentage {
        font-size: 11px;
        display: inline-flex;
        align-items: center;
        &.negative {
          color: #ff0000;
        }
        &.postive {
          color: #00c908;
        }
        i {
          display: inline-flex;
          width: 16px;
          height: 10px;
        }
      }
    }
  }
  &__spinner {
    width: 50px;
    height: 50px;
    @media only screen and (min-width: 1024px) {
      width: 25px;
      height: 25px;
    }
  }
}
// Dark Mode
.body {
  &--dark {
    .kpi-list {
      &__section {
        &--date {
          border-bottom: 1px solid #353535;
          @media only screen and (min-width: 768px) {
            border-right: 1px solid #353535;
            border-bottom: 0;
          }
          @media only screen and (min-width: 1300px) {
            border-bottom: 0;
          }
        }

        &--result {
          border-bottom: 1px solid #353535;

          @media only screen and (min-width: 768px) {
            border-bottom: 0;
          }
          @media only screen and (min-width: 1300px) {
            border-right: 1px solid #353535;
          }
          &:last-child {
            border-bottom: 0;
          }
        }

        .timestamp {
          .label {
            color: #fff;
          }
          .amount {
            color: #fff;
          }
        }
        .label {
          color: #fff;
        }
      }
    }
  }
}
</style>
